import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import _ from 'lodash';
import {
  setReportWorkFlows,
  setCurrentReport,
  setReportDealerships,
  setCurrentReportTab,
  setReportFilters,
  setReportDepartments,
  setEditDepartments,
  setReportMonths,
} from '../actions/apiSetInfo';
import { filterReport, filterMonthlyReport } from '../actions/apiReports';
import { addUserInstallation, deleteUserInstallation } from '../actions/users';
import {
  lookupUserById,
  lookupWorkFlowByName,
  lookupWorkFlowById,
  activeEditDepartment,
} from '../actions/lookups';
import { addNotificationSetting } from '../actions/apiNotifications';
import { updateDepartmentSetting, updateVehicleColumn } from '../actions/apiDepartmentUpdates';
import { sendEstimate } from '../actions/apiEstimates';
import { updateEmailReport } from '../actions/apiEmailReports';
import { change_page } from '../actions/toggleMenu';

const DropdownMultiple = ({
  title,
  list: initialList = [],
  update_type,
  user_id,
  dealers,
  data,
  department_id,
  vehicle_column_id,
  set_work_flows,
  report_dealerships,
  email_report,
  value,
  parentid,
  report_departments,
  report_months,
  edit_departments,
  report_work_flows,
  report_filters,
  departments,
  tabIndex,
  toggleItem,
}) => {
  const dispatch = useDispatch();
  const [listOpen, setListOpen] = useState(false);
  const [list, setList] = useState(initialList);

  useEffect(() => {
    setList(initialList);
  }, [initialList]);

  const {
    searched_vehicles,
    current_report_tab,
    departments: reduxDepartments,
    related_installations,
    report_start_date,
    report_end_date,
    report_dealerships: reduxReportDealerships,
    report_departments: reduxReportDepartments,
    report_data,
    report_filters: reduxReportFilters,
    report_work_flows: reduxReportWorkFlows,
    report_months: reduxReportMonths,
    set_work_flows: reduxSetWorkFlows,
  } = useSelector(
    (state) => ({
      searched_vehicles: state.settings_refresh.searched_vehicles,
      current_report_tab: state.settings_reports.current_report_tab,
      departments: state.settings_departments.departments,
      related_installations: state.settings_dealerships.related_installations,
      report_start_date: state.settings_reports.report_start_date,
      report_end_date: state.settings_reports.report_end_date,
      report_dealerships: state.settings_reports.report_dealerships,
      report_departments: state.settings_reports.report_departments,
      report_data: state.settings_reports.report_data,
      report_filters: state.settings_reports.report_filters,
      report_work_flows: state.settings_reports.report_work_flows,
      report_months: state.settings_reports.report_months,
      set_work_flows: state.settings_departments.work_flows,
    }),
    shallowEqual,
  );

  const close = useCallback(() => {
    setListOpen(false);
  }, []);

  useEffect(() => {
    const handler = () => {
      if (listOpen) {
        close();
      }
    };

    if (listOpen) {
      window.addEventListener('click', handler);
    }

    return () => {
      window.removeEventListener('click', handler);
    };
  }, [listOpen, close]);

  const headerTitle = useMemo(() => {
    const count = list.filter((a) => a.selected).length;
    const labels = list.filter((a) => a.selected);

    let titleStr = `(${count}) `;

    if (count === 0) {
      return titleStr;
    }
    if (count === 1) {
      return `${titleStr} ${labels[0]?.label || ''}`;
    }
    if (count > 1) {
      let result = titleStr;
      labels.forEach((option, index) => {
        if (index > 2) {
          result = `${result} ...`;
        } else if (index === count - 1) {
          result = `${result} ${option.label || ''}`;
        } else {
          result = `${result} ${option.label || ''} |`;
        }
      });
      return result;
    }
  }, [list, title]);

  const toggleList = useCallback(() => {
    setListOpen((prev) => !prev);
  }, []);

  const toggleSelected = useCallback(
    (id) => {
      const index = _.findIndex(list, { id: parseInt(id) });

      const newList = list.map((item, ind) => {
        if (index !== ind) {
          return item;
        }
        const updatedItem = { ...item, selected: !item.selected };

        if (update_type === 'user_installation') {
          if (updatedItem.selected) {
            const data = { installation_id: id, user_id };
            dispatch(addUserInstallation(data, 'installation'));
          } else {
            const user = dispatch(lookupUserById(user_id));
            if (user?.user_installations?.length > 1) {
              dispatch(deleteUserInstallation(item.dataid, 'installation'));
            } else {
              alert('User Must Have At Least One Installation');
            }
          }
        } else if (update_type === 'notification_settings') {
          const dealer_values = dealers?.split(',') || [];
          if (updatedItem.selected) {
            dealer_values.push(item.subdomain);
            const newData = { ...data, dealership: dealer_values.join() };
            dispatch(addNotificationSetting(newData, 'addNotificationSetting'));
          } else {
            const dealersFiltered = dealer_values.filter((value) => value !== item.subdomain);
            const newData = { ...data, dealership: dealersFiltered.join() };
            dispatch(addNotificationSetting(newData, 'addNotificationSetting'));
          }
        } else if (update_type === 'department_dealerships') {
          const dealersArray = dealers?.split(',') || [];
          if (updatedItem.selected) {
            dealersArray.push(item.subdomain);
            const data = { id: department_id, dealerships: dealersArray.join() };
            dispatch(updateDepartmentSetting(department_id, data, 'editVehicleColumnError'));
          } else {
            const dealersFiltered = dealersArray.filter((value) => value !== item.subdomain);
            const data = { id: department_id, dealerships: dealersFiltered.join() };
            dispatch(updateDepartmentSetting(department_id, data, 'editVehicleColumnError'));
          }
        } else if (update_type === 'vehicle_column_locations') {
          const dealersArray = dealers?.split(',') || [];
          if (updatedItem.selected) {
            dealersArray.push(item.id);
            const data = { id: vehicle_column_id, location: dealersArray.join() };
            dispatch(updateVehicleColumn(vehicle_column_id, data, 'editVehicleColumnError'));
          } else {
            const dealersFiltered = dealersArray.filter((value) => value.toString() !== item.id.toString());
            const data = { id: vehicle_column_id, location: dealersFiltered.join() };
            dispatch(updateVehicleColumn(vehicle_column_id, data, 'editVehicleColumnError'));
          }
        } else if (update_type === 'work_flows') {
          const work_flows = set_work_flows?.split(',') || [];
          if (updatedItem.selected) {
            work_flows.push(item.label);
            const data = { id: department_id, work_flow: work_flows.join() };
            dispatch(updateDepartmentSetting(department_id, data, 'work_flows'));
          } else {
            const work_flowsFiltered = work_flows.filter((value) => value !== item.label);
            const data = { id: department_id, work_flow: work_flowsFiltered.join() };
            dispatch(updateDepartmentSetting(department_id, data, 'work_flows'));
          }
        } else if (update_type === 'select-recipients') {
          let recipients = value?.split(',') || [];
          const estimate_id = item.estimate_id;
          if (updatedItem.selected) {
            if (!recipients.includes(item.id.toString())) {
              recipients.push(item.id);
            }
          } else {
            recipients = recipients.filter((x) => x !== item.id.toString());
          }
          const uniqueRecipients = [...new Set(recipients)];
          const newData = {
            id: estimate_id,
            vehicle_id: parentid,
            recipients: uniqueRecipients.join(),
          };
          dispatch(sendEstimate(estimate_id, newData, 'select-recipients'));
        } else if (update_type === 'report_dealerships') {
          const report_dealers = report_dealerships?.split(',') || [];
          if (updatedItem.selected) {
            if (!report_dealers.includes(item.subdomain)) {
              report_dealers.push(item.subdomain);
            }
            dispatch(setReportDealerships(report_dealers.join()));
          } else {
            const report_dealersFiltered = report_dealers.filter((value) => value !== item.subdomain);
            dispatch(setReportDealerships(report_dealersFiltered.join('')));
          }
        } else if (update_type === 'email_report_dealerships') {
          const report_dealers = email_report?.report_dealerships?.split(',') || [];
          const id = email_report?.id;
          if (updatedItem.selected) {
            if (!report_dealers.includes(item.subdomain)) {
              report_dealers.push(item.subdomain);
            }
            const data = { id, report_dealerships: report_dealers.join() };
            dispatch(updateEmailReport(id, data, 'report_dealerships'));
          } else {
            const report_dealersFiltered = report_dealers.filter((value) => value !== item.subdomain);
            const data = { id, report_dealerships: report_dealersFiltered.join() };
            dispatch(updateEmailReport(id, data, 'report_dealerships'));
          }
        } else if (update_type === 'email_report_users') {
          const report_users = email_report?.report_users?.split(',') || [];
          const id = email_report?.id;
          if (updatedItem.selected) {
            if (!report_users.includes(item.user_name)) {
              report_users.push(item.user_name);
            }
            const data = { id, report_users: report_users.join() };
            dispatch(updateEmailReport(id, data, 'report_users'));
          } else {
            const report_usersFiltered = report_users.filter((value) => value !== item.user_name);
            const data = { id, report_users: report_usersFiltered.join() };
            dispatch(updateEmailReport(id, data, 'report_users'));
          }
        } else if (update_type === 'email_report_times') {
          const report_times = email_report?.report_run_time?.split(',') || [];
          const id = email_report?.id;
          if (updatedItem.selected) {
            if (!report_times.includes(item.value)) {
              report_times.push(item.value);
            }
            const data = { id, report_run_time: report_times.join() };
            dispatch(updateEmailReport(id, data, 'report_times'));
          } else {
            const report_timesFiltered = report_times.filter((value) => value !== item.value);
            const data = { id, report_run_time: report_timesFiltered.join() };
            dispatch(updateEmailReport(id, data, 'report_times'));
          }
        } else if (update_type === 'email_report_days') {
          const report_days = email_report?.report_run_day?.split(',') || [];
          const id = email_report?.id;
          if (updatedItem.selected) {
            if (!report_days.includes(item.value)) {
              report_days.push(item.value);
            }
            const data = { id, report_run_day: report_days.join() };
            dispatch(updateEmailReport(id, data, 'report_dealerships'));
          } else {
            const report_daysFiltered = report_days.filter((x) => x !== item.value);
            const data = { id, report_run_day: report_daysFiltered.join() };
            dispatch(updateEmailReport(id, data, 'report_run_day'));
          }
        } else if (update_type === 'report_departments') {
          const departments = report_departments?.split(',') || [];
          if (updatedItem.selected) {
            if (!departments.includes(item.id)) {
              departments.push(item.id);
            }
            dispatch(setReportDepartments(departments.join()));
          } else {
            const departmentsFiltered = departments.filter((value) => parseInt(value) !== parseInt(item.id));
            dispatch(setReportDepartments(departmentsFiltered.join()));
          }
        } else if (update_type === 'report_months') {
          const months = report_months?.split(',') || [];
          if (updatedItem.selected) {
            if (!months.includes(item.value)) {
              months.push(item.value);
            }
            dispatch(setReportMonths(months.join()));
          } else {
            const monthsFiltered = months.filter((x) => x !== item.value);
            dispatch(setReportMonths(monthsFiltered.join()));
          }
        } else if (update_type === 'edit_departments') {
          const editDepartments = edit_departments?.split(',') || [];
          if (updatedItem.selected) {
            if (!editDepartments.includes(item.id)) {
              editDepartments.push(item.id);
            }
            dispatch(activeEditDepartment(item.id));
            dispatch(setEditDepartments(editDepartments.join()));
          } else {
            const editDepartmentsFiltered = editDepartments.filter((value) => parseInt(value) !== parseInt(item.id));
            dispatch(setEditDepartments(editDepartmentsFiltered.join()));
          }
        } else if (update_type === 'report_work_flows') {
          const work_flows = report_work_flows?.split(',') || [];
          if (updatedItem.selected) {
            if (!work_flows.includes(item.id)) {
              work_flows.push(item.id);
            }
            dispatch(setReportWorkFlows(work_flows.join()));
          } else {
            const work_flowsFiltered = work_flows.filter((value) => value !== item.id);
            dispatch(setReportWorkFlows(work_flowsFiltered.join()));
          }
        } else if (update_type === 'update_steps_with_report_work_flows') {
          const work_flows = report_work_flows?.split(',') || [];
          const work_flow_departmentsArray = [];
          let wf = [];

          if (updatedItem.selected) {
            if (!work_flows.includes(item.id)) {
              work_flows.push(item.id);
            }
            work_flows.forEach((report_work_flow) => {
              if (report_work_flow !== '') {
                const work_flow = dispatch(lookupWorkFlowById(report_work_flow));
                departments.forEach((department) => {
                  if (department.department_type === 'department') {
                    const department_found = _.find(work_flow.work_flow_properties, {
                      department_id: department.id,
                    });
                    if (department_found) {
                      work_flow_departmentsArray.push(department.id);
                    }
                  }
                });
              }
            });
            wf = [...new Set(work_flow_departmentsArray)];
            Promise.all([dispatch(setReportWorkFlows(work_flows.join()))]).then(() => {
              dispatch(setReportDepartments(wf.join()));
            });
          } else {
            const work_flowsFiltered = work_flows.filter((value) => value !== item.id);
            work_flowsFiltered.forEach((report_work_flow) => {
              if (report_work_flow !== '') {
                const work_flow = dispatch(lookupWorkFlowById(report_work_flow));
                departments.forEach((department) => {
                  if (department.department_type === 'department') {
                    const department_found = _.find(work_flow.work_flow_properties, {
                      department_id: department.id,
                    });
                    if (department_found) {
                      work_flow_departmentsArray.push(department.id);
                    }
                  }
                });
              }
            });
            wf = [...new Set(work_flow_departmentsArray)];
            Promise.all([dispatch(setReportWorkFlows(work_flowsFiltered.join()))]).then(() => {
              dispatch(setReportDepartments(wf.join()));
            });
          }
        } else if (update_type === 'report_filters') {
          const filters = report_filters?.split(',') || [];
          if (updatedItem.selected) {
            if (!filters.includes(item.id)) {
              filters.push(item.id);
            }
            dispatch(setReportFilters(filters.join()));
          } else {
            const filtersFiltered = filters.filter((value) => parseInt(value) !== parseInt(item.id));
            dispatch(setReportFilters(filtersFiltered.join()));
          }
        }

        return updatedItem;
      });

      setList(newList);
    },
    [
      list,
      update_type,
      user_id,
      dealers,
      data,
      department_id,
      vehicle_column_id,
      set_work_flows,
      report_dealerships,
      email_report,
      value,
      parentid,
      report_departments,
      report_months,
      edit_departments,
      report_work_flows,
      report_filters,
      departments,
      dispatch,
    ]
  );

  const resetThenSet = useCallback((id, key) => {
    setList((prevList) => {
      const temp = JSON.parse(JSON.stringify(prevList));
      temp.forEach((item) => (item.selected = false));
      temp[id].selected = true;
      return temp;
    });
  }, []);

  return (
    <div>
      <div className="dd-wrapper" key="testkey" tabIndex={tabIndex}>
        <div
          className="dd-header"
          onClick={(e) => {
            e.stopPropagation();
            toggleList();
          }}
        >
          <div className="dd-header-title">{headerTitle}</div>
          <div className="text-muted">
            {listOpen ? (
              <i className="fal fa-2x fa-angle-up text-muted" />
            ) : (
              <i className="fal fa-2x fa-angle-down text-muted" />
            )}
          </div>
        </div>
        {listOpen && (
          <div>
            <ul
              className={list.length > 10 ? 'dd-list scroll' : 'dd-list'}
              onClick={(e) => e.stopPropagation()}
            >
              {list.map((item) => (
                <li
                  className={item.selected ? 'dd-list-item selected' : 'dd-list-item'}
                  key={`dd_${item.id}`}
                  onClick={() => toggleSelected(item.id)}
                >
                  {item.label}{' '}
                  {item.selected ? (
                    <span>
                      <i className="fas fa-check float-right" />
                    </span>
                  ) : (
                    ''
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default DropdownMultiple;